const data = {
    recommend: [{
        id: '0',
        title: '热门'
    }, {
        id: '1',
        title: '潮流'
    }, {
        id: '3',
        title: '新品'
    }, {
        id: '4',
        title: '经典'
    }, {
        id: '5',
        title: '学生'
    }, {
        id: '6',
        title: '轻奢'
    }, {
        id: '7',
        title: '经典'
    }],
    notices: [{
        title: '商城改版，全新优化'
    }, {
        title: '无缝滚动第二行无缝滚动第二行'
    }, {
        title: '商城改版，全新优化，敬请期待三~'
    }],
    goods: [{
        goodscood: '0',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题名称，这里是产品名称到这过了了',
        price: '1999',
        oldprice: '2999'
    }, {
        goodscood: '1',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题名称，这里是产品名称到这过了了',
        price: '1969',
        oldprice: '3999'
    }, {
        goodscood: '2',
        image: require('../assets/img/home/shpinpng.png'),
        title: '标题名称，这里是产品名称到这过了了',
        price: '2969',
        oldprice: '3999'
    }, {
        goodscood: '3',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题名了',
        price: '1909',
        oldprice: '3899'
    }, {
        goodscood: '4',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题',
        price: '1909',
        oldprice: '3899'
    }],
    images: [
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/952e43e0-313d-4a6e-a867-f2c08934b797.jpg',
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/d08da969-5772-450b-acd1-764f52c587ed.jpg',
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/17d6f7ae-0bda-4d87-b59d-6b8fe410c7e0.jpg'
    ],
    imagessmall: [
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/952e43e0-313d-4a6e-a867-f2c08934b797.jpg',
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/d08da969-5772-450b-acd1-764f52c587ed.jpg',
        'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/17d6f7ae-0bda-4d87-b59d-6b8fe410c7e0.jpg'
    ],
    menus: [{
        menuIcon: require('../assets/img/home/middletab/youyanji.png'),
        menuTitle: '油烟机',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/ranqizao.png'),
        menuTitle: '燃气灶',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/hotwater.png'),
        menuTitle: '热水器',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/xiaodugui.png'),
        menuTitle: '消毒柜',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/carele.png'),
        menuTitle: '车载电器',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/znjj.png'),
        menuTitle: '智能家居',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/zqlhzq.png'),
        menuTitle: '中秋礼盒',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }, {
        menuIcon: require('../assets/img/home/middletab/scly.png'),
        menuTitle: '商城礼遇',
        menuCode: '1233',
        menuUrl: 'http://www.baidu.com'
    }],
    listgoods: [{
        goodscood: '0',
        image: require('../assets/img/home/listgoods1.png'),
        title: '这里是产品标题名称，这里是产品名称到这过了了',
        price: '1999',
        oldprice: '2999'
    }, {
        goodscood: '1',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题名称，这里是产品名称到这过了了',
        price: '1969',
        oldprice: '3999'
    }, {
        goodscood: '2',
        image: require('../assets/img/home/listgoods1.png'),
        title: '标题名称，这里是产品名称到这过了了',
        price: '2969',
        oldprice: '3999'
    }, {
        goodscood: '3',
        image: require('../assets/img/home/shpinpng.png'),
        title: '这里是产品标题名了',
        price: '1909',
        oldprice: '3899'
    }, {
        goodscood: '4',
        image: require('../assets/img/home/listgoods1.png'),
        title: '这里是产品标题',
        price: '1909',
        oldprice: '3899'
    }],
    gooddetail: {
        images: [
            'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/952e43e0-313d-4a6e-a867-f2c08934b797.jpg',
            'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/d08da969-5772-450b-acd1-764f52c587ed.jpg',
            'http://eslink-emall.oss-cn-beijing.aliyuncs.com/upload/image/201806/17d6f7ae-0bda-4d87-b59d-6b8fe410c7e0.jpg'
        ],
        goodword: [{
            goodscood: '0',
            image: require('../assets/img/home/shpinpng.png'),
            title: '这里是标题介绍这里是标题介绍这里是标题介绍这里是标题介绍这里是标题介绍',
            price: '1999',
            oldprice: '2999'
        }]
    }
};
export default data;
